var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currentInfo"},[_c('vxe-grid',{ref:"table",staticClass:"vxe-table-element",attrs:{"border":"","show-overflow":"","resizable":"","size":"mini","align":"left","auto-resize":true,"data":_vm.tableData,"columns":_vm.columnList,"max-height":_vm.$store.state.app.tableHeight,"column-min-width":"150"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }